module.exports = __webpack_public_path__ + "images/landing/video-previews/Anatomy_of_a_Script_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Anatomy_of_a_Script_2x.jpg
// module id = 0HKl
// module chunks = 1